import React from 'react';
import Article from '../components/Article';
import Menu from '../components/Menu';

import styles from './index.module.css';

const IndexPage = (props) => {
  const postEdges = props.data.allMarkdownRemark ? props.data.allMarkdownRemark.edges : [];

  return (
    <div className={styles.indexContent}>
      <Menu className={styles.menu} />
      <div className={styles.hero}>
        <h1>Yet another blog..</h1>
        <p>
          On developing awesome code, living in the U.S. and traveling!
        </p>
      </div>
      {postEdges.map(post => {
        if (!post.node.frontmatter.date) {
          // Skip posts without a date
          return false;
        }
        return (
          <Article
            title={post.node.frontmatter.title}
            date={post.node.frontmatter.date}
            excerpt={post.node.excerpt}
            slug={post.node.fields.slug}
            key={post.node.fields.slug}
          />
        );
      })}
    </div>
  );
};

export default IndexPage;

/* eslint no-undef: off */
export const IndexQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            date(formatString: "DD.MM.YYYY")
          }
          excerpt(pruneLength: 200)
          timeToRead
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js